import React, { FC, ReactElement, useState } from 'react';
import { useSearchParams } from 'react-router-dom';

import Button, { BUTTON_TYPES } from 'buyside/components/presentation/Button/button';
import IndexFilterChips from 'buyside/components/presentation/IndexFilterChips/IndexFilterChips';
import Modal from 'buyside/components/presentation/Modal/modal';

import SlidersIcon from 'buyside/svgs/sliders.svg';

import styles from './mobileFilterStyles.scss';

const MobileFilter: FC<{ children: ReactElement }> = ({ children }): ReactElement => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const [searchParams] = useSearchParams();
  const selectedFilterCount = Array.from(searchParams.keys()).filter(
    key => !['page', 'recommended', 'fpid'].includes(key)
  ).length;

  return (
    <>
      <div className={styles.openModalButton}>
        <Button
          type={BUTTON_TYPES.LINK}
          text="Show Filters"
          icon={SlidersIcon}
          onClick={() => setIsModalOpen(true)}
          className={styles.mobileFilterToggleLink}
        />
        {Boolean(selectedFilterCount) && (
          <div className={styles.filterNumber}>{selectedFilterCount}</div>
        )}
      </div>
      <Modal
        closeOnOverlayClick={false}
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        size="full"
        title="Filters"
      >
        <div className={styles.filterContainer}>
          <IndexFilterChips />
          {children}
        </div>
      </Modal>
    </>
  );
};

export default MobileFilter;
